import { useCallback, useState } from 'react'

const useEmployeeFilter = () => {
  const [searchValue, setSearchValue] = useState('')
  const handleChange = useCallback(({ target: { value } }) => {
    setSearchValue(value)
  }, [])
  return { searchValue, handleChange }
}

export default useEmployeeFilter
